import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { DialogProgrammatic, NotificationProgrammatic } from 'buefy';

import {
  getById,
  remove as removeJobSite,
  update as updateJobsite,
  create as createJobsite,
  changeCustomer,
} from '@/service/jobSite.service';
import CustomerService from '@/service/customer.service';

import FlowrightAddress from '@/components/address/FlowrightAddress.vue';
import WorkOrderSiteHistory from '@/components/workorders/WorkorderSiteHistory.vue';
import CustomerAutocomplete from '@/components/customers/CustomerAutocomplete.vue';

import { JobSite } from '@/types/JobSite';
import { Customer } from '@/types/Customer';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsiteDetails',
  setup(__props) {

const address = ref({});
const selectedCustomer = ref(null);
const router = useRouter();
const route = useRoute();
const jobsite = ref<JobSite>(null);
const customer = ref<Customer>(null);
const isCustomerPickerActive = ref(false);
const addressForm = ref(null);
const fetchJobsite = async () => {
  try {
    jobsite.value = await getById(route.params.id);
    if (jobsite.value.ezCare === null) {
      jobsite.value.ezCare = '';
    }

    jobsite.value.ezCareStartDate = jobsite.value.ezCareStartDate ? new Date(jobsite.value.ezCareStartDate) : null;

    address.value = {
      street: jobsite.value.street,
      street2: jobsite.value.street2,
      city: jobsite.value.city,
      state: jobsite.value.state,
      zip: jobsite.value.zip,
    };
    await fetchCustomer(jobsite.value.customerId);
  } catch (error) {
    console.error('Error:', error);
  }
};

watch(address, () => {
  jobsite.value.street = address.value.street;
  jobsite.value.street2 = address.value.street2;
  jobsite.value.city = address.value.city;
  jobsite.value.state = address.value.state;
  jobsite.value.zip = address.value.zip;
});

const id = computed(() => route.params.id);
const isNew = computed(() => id.value === 'new');

onMounted(() => {
  if (!isNew.value) {
    fetchJobsite();
  } else {
    const customerId = route.query.customerId as string;
    jobsite.value = {
      street: '',
      street2: '',
      city: '',
      state: '',
      zip: '',
      ezCare: '',
      ezCareStartDate: null,
      customerId,
      doNotService: false,
      nickname: '',
    };
    fetchCustomer(customerId);
  }
});

async function fetchCustomer(id: string) {
  customer.value = await CustomerService.get(id);
}

function confirmDelete() {
  DialogProgrammatic.confirm({
    title: 'Delete Jobsite',
    message: 'Are you sure you want to delete this jobsite?',
    type: 'is-danger',
    hasIcon: true,
    onConfirm: () => {
      removeJobSite(jobsite.value.id)
        .then(() => toCustomerEdit(jobsite.value.customerId))
        .catch(error => {
          console.error('Error deleting jobsite:', error);
          NotificationProgrammatic.open({
            message: 'An error occurred while deleting the jobsite',
            type: 'is-danger',
          });
        });
    },
  });
}

const isSaving = ref(false);

async function save() {
  isSaving.value = true;
  try {
    if (isNew.value) {
      await createJobsite({ ...jobsite.value });
      NotificationProgrammatic.open({
        message: 'Jobsite created successfully',
        type: 'is-success',
      });
    } else {
      await updateJobsite(id.value, { ...jobsite.value });
      NotificationProgrammatic.open({
        message: 'Jobsite updated successfully',
        type: 'is-success',
      });
    }
    toCustomerEdit(jobsite.value.customerId);
  } catch (error) {
    NotificationProgrammatic.open({
      message: 'An error occurred while saving the jobsite',
      type: 'is-danger',
    });
  } finally {
    isSaving.value = false;
  }
}

function toCustomerEdit(id: string) {
  router.push({ name: 'customer-edit', params: { customerId: id } });
}

function cancelCustomerChange() {
  selectedCustomer.value = null;
  isCustomerPickerActive.value = false;
}

async function submitCustomerChange() {
  if (!selectedCustomer.value?.id) {
    NotificationProgrammatic.open({
      message: 'Please select a customer',
      type: 'is-danger',
    });
    return;
  }

  try {
    if (!isNew.value) {
      await changeCustomer(jobsite.value.id, selectedCustomer.value.id);
    }
    jobsite.value.customerId = selectedCustomer.value.id;
    await fetchCustomer(selectedCustomer.value.id);
    selectedCustomer.value = null;
    isCustomerPickerActive.value = false;
    NotificationProgrammatic.open({
      message: 'Customer updated successfully',
      type: 'is-success',
    });
    toCustomerEdit(customer.value.id);
  } catch (error) {
    console.error('Error changing customer:', error);
    NotificationProgrammatic.open({
      message: 'Failed to update customer',
      type: 'is-danger',
    });
  }
}

return { __sfc: true,address, selectedCustomer, router, route, jobsite, customer, isCustomerPickerActive, addressForm, fetchJobsite, id, isNew, fetchCustomer, confirmDelete, isSaving, save, toCustomerEdit, cancelCustomerChange, submitCustomerChange, FlowrightAddress, WorkOrderSiteHistory, CustomerAutocomplete }
}

})